import { useState } from "react";
import FileInput from "./fileInput";
import { IWatch } from "../../watches/adminWatches";
import { useWatches } from "../../../../../context/watchProvider";
import { deleteObject, getStorage, ref } from "firebase/storage";
import AdminButton from "../../../../core/admin/adminButton";
import AdminSpinner from "../../../../core/admin/adminSpinner";
import { CloseIcon } from "../../../../../img/svg/adminIcons";

export default function ImagesUploader({ watch, update }: { watch: IWatch | null, update: () => void }) {

    const { updateWatch } = useWatches();
    const [uploadLoading, setUploadLoading] = useState(false);
    const [deletion, setDeletion] = useState<number | null>(null);
    const [deleteLoading, setDeleteLoading] = useState<number | null>(null);

    const maxImages = watch?.images?.length >= 5 || false;

    const uploadImage = async (newImagesData: { imgUrl: string, cImgUrl: string }[]) => {
        try {
            if (!watch?.id) {
                setUploadLoading(false);
                return null;
            }
            
            let currentImages = watch.images || [];
            if (currentImages.length >= 5) {
                setUploadLoading(false);
                return null;
            }

            const formattedNewImages = newImagesData.map(img => ({
                ...img,
                order: 0
            }));

            // Adicionar apenas o que couber (limite de 5 no total)
            const capacity = 5 - currentImages.length;
            const imagesToAdd = formattedNewImages.slice(0, capacity);
            
            const images = [...currentImages, ...imagesToAdd];
            
            await updateWatch(watch?.id, { images });
            update();
            setUploadLoading(false);
        } catch (error) {
            console.log(error);
            setUploadLoading(false);
        }
    }

    const deleteImage = async (imageIdx: number) => {
        if (!watch?.id || !watch?.images?.length) {
            return null;
        }
        setDeleteLoading(imageIdx);
        setDeletion(null);
        const storage = getStorage();
        // excluir imagens do relógio
        try {

            const url = watch.images[imageIdx].imgUrl;
            if (url) {
                const imageRef = ref(storage, url);
                await deleteObject(imageRef);
            }
        } catch (error) {
            console.log(error);
        }
        try {
            const cUrl = watch.images[imageIdx].cImgUrl;
            if (cUrl) {
                const cImageRef = ref(storage, cUrl);
                await deleteObject(cImageRef);
            }
        } catch (error) {
            console.log(error);
        }
        try {
            let newImages = watch.images.filter((w: IWatch, i: number) => i !== imageIdx);

            await updateWatch(watch.id, { images: newImages });
            update();
            setDeleteLoading(null);
        } catch (error) {
            console.log(error);
            setDeleteLoading(null);
        }

    }

    return (
        <div className="rounded-xl border border-gray-200 bg-gray-50 w-full p-4 flex flex-wrap gap-4">
            {
                watch?.images?.length ?
                    watch.images.map((w: IWatch, i: number) => (
                        <div key={i} className="w-32 h-32 rounded-xl border border-gray-200 bg-white flex items-center justify-center relative">
                            {
                                deleteLoading === i ?
                                    <span className="text-gray-500"><AdminSpinner /></span>
                                    : deletion === i ?
                                        <div className="flex w-full flex-col gap-2 px-2">
                                            <p className="text-center text-xs font-semibold text-gray-700">Excluir imagem?</p>
                                            <AdminButton size="sm" variant="danger" onClick={() => deleteImage(i)} fullWidth>Excluir</AdminButton>
                                            <AdminButton size="sm" variant="secondary" onClick={() => setDeletion(null)} fullWidth>Cancelar</AdminButton>
                                        </div>
                                        :
                                        <div className="h-full w-full overflow-hidden rounded-xl">
                                            <img src={w.cImgUrl} alt="relojo" className="h-full w-full object-cover"/>
                                            {
                                                i === 0 ?
                                                    <span className="absolute bottom-1.5 left-1.5 rounded-full bg-black/70 px-2 py-0.5 text-[10px] font-bold text-white">Capa</span>
                                                    : null
                                            }
                                            <button onClick={() => setDeletion(i)} title="Excluir" aria-label="Excluir imagem" className="absolute -top-2 -right-2 flex h-7 w-7 items-center justify-center rounded-full bg-red-600 text-white shadow hover:bg-red-700"><CloseIcon width="14px" /></button>
                                        </div>
                            }
                        </div>
                    ))
                    : null
            }
            {
                watch?.id && (!watch?.images?.length || watch?.images?.length < 5) ?
                    <FileInput watchId={watch.id} isDisabled={maxImages} saveImgUrls={uploadImage} loading={uploadLoading} setLoading={setUploadLoading} />
                    : null
            }

        </div>
    )
}
